import React, { useState } from "react"
import styled from "styled-components"
import { motion, AnimatePresence } from "framer-motion"

import DropDownContext from "./DropDownContext"

const StyledCard = styled.div`
  margin: 10px 0;
  background-color: var(--gray-bg);
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  z-index: 0;
`

const Head = styled.div`
  cursor: pointer;
  position: relative;
  z-index: 20;
`

type Props = {
  head: JSX.Element
  dropdown: JSX.Element
}

const CollapsableCard = ({head, dropdown}: Props) => {
  const [isDropped, setIsDropped] = useState(false)
  const toggleDropDown = () => { setIsDropped(!isDropped) }

  return (
      <StyledCard>
        <DropDownContext.Provider value={{isDropped, toggleDropDown}}>
          <Head onClick={toggleDropDown}>
            {head}
          </Head>
        </DropDownContext.Provider>
        
          <AnimatePresence>
            {isDropped &&
              <motion.div
                style={{ position: "relative", zIndex: 10 }}
                initial={{ height:"0" }}
                animate={{ height:"100%" }}
                exit={{ height: "0" }}
                transition={{ type: "tween", ease: "easeInOut" }}
                >
                {dropdown}
              </motion.div>
            }
          </AnimatePresence>
      </StyledCard> 
  )
}

export default CollapsableCard